<template>
  <input class="form-control" type="time" :step="step" v-model="timeString">
</template>

<script>
import { parse, format } from "date-fns";
import log from "@/utils/logger";

export default {
  name: "TimeSelector",
  props: {
    date: Date,
    step: {
      type: String,
      default: "900"
    }
  },
  emits: [ "update:date" ],
  computed: {
    timeString: {
      get()
      {
        if (!this.date)
        {
          return null;
        }

        return format(this.date, "HH:mm");
      },
      set(value)
      {
        let date = null;

        if (value)
        {
          try
          {
            date = parse(value, "HH:mm", new Date());
          }
          catch (e)
          {
            log.error("Failed to parse date value [%s] - %o", value, e);
          }
        }

        this.$emit("update:date", date);
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>